import React, { useEffect, useState } from "react";
import {
  DOWNLOAD_BUTTON,
  DOWNLOAD_COPY,
  detectExtension,
  dismiss,
  isChromium,
  isDismissed,
  isKnownInstalled,
  markInstalled,
  storeUrl,
} from "../lib/extensionBanner";

// Announcement for the Chrome extension, shown on the LANDING PAGE ONLY (Landing renders it; nothing
// else does). Hidden once dismissed, in browsers that can't run the extension (not Chromium), and for
// anyone who already has it. The extension is live on the Web Store, so Download links straight to the
// listing in a new tab -- no sign-in or resume gate first.
export default function ExtensionBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setVisible(false);
    if (isDismissed() || isKnownInstalled() || !isChromium()) return undefined;
    detectExtension().then((state) => {
      if (state === "installed") markInstalled();
      // "unknown" (an origin the extension can't be reached from, or no answer) still shows the banner:
      // it is harmless, and hiding on a guess would hide it from everyone on those origins.
      if (!cancelled && state !== "installed") setVisible(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!visible) return null;

  const onDismiss = () => {
    dismiss();
    setVisible(false);
  };

  return (
    <div
      role="region"
      aria-label="Announcement"
      data-testid="extension-banner"
      style={{ background: "#178461", color: "#fff", fontFamily: "Inter, sans-serif" }}
    >
      <div className="mx-auto flex flex-wrap items-center gap-x-5 gap-y-2" style={{ maxWidth: 1100, padding: "10px 24px" }}>
        <p style={{ flex: "1 1 320px", margin: 0, fontSize: 14, fontWeight: 600, lineHeight: 1.4 }}>
          {DOWNLOAD_COPY}
        </p>
        <a
          href={storeUrl()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="extension-banner-download"
          style={{
            background: "#1a1a18", color: "#fff", border: 0, borderRadius: 999, padding: "8px 18px",
            fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", textDecoration: "none",
            display: "inline-block",
          }}
        >
          {DOWNLOAD_BUTTON}
        </a>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss this announcement"
          data-testid="extension-banner-dismiss"
          style={{ background: "none", border: 0, color: "#fff", fontSize: 22, lineHeight: 1, cursor: "pointer", padding: "2px 6px" }}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
  );
}
